import { Injectable } from '@angular/core';
import { ShowAlert } from '@app/core/actions/alert';
import { InfoMessage } from '@app/core/models/alert/info-message';
import * as BulkExportActions from '@app/pcs/actions/bulk-export';
import { BulkExportActionTypes, ExportPdfBulkFail } from '@app/pcs/actions/bulk-export';
import { DossierSearchItem, GridType } from '@app/pcs/models';
import { DossierToExport } from '@app/pcs/models/bulk-export';
import { BulkExportDataService } from '@app/pcs/services/bulk-export-data.service';
import { GridService } from '@app/pcs/services/grid.service';
import { PdfExportOptions } from '@app/pcs/shared/export-options/pdf-export-options/models/pdf-export-options';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapPayload } from '@util';
import * as R from 'ramda';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap, withLatestFrom } from 'rxjs/operators';

type ToDossierForExport = (dossiers: DossierSearchItem[]) => DossierToExport[];
const toDossierForExport: ToDossierForExport = R.map(R.pick(['dossierId', 'version']));

@Injectable()
export class BulkExportEffects {

  private dossiersToExport$ = this.gridService.getSelectedData(GridType.Search).pipe(map(toDossierForExport));

  $exportPdfBulk = createEffect(() => this.actions$.pipe(
    ofType<BulkExportActions.ExportPdfBulk>(BulkExportActionTypes.ExportPdfBulk),
    mapPayload(),
    withLatestFrom(this.dossiersToExport$),
    exhaustMap(([exportParts, dossiers]: [PdfExportOptions, DossierToExport[]]) =>
      this.bulkExportDataService.exportPdfBulk({exportParts, dossiers}).pipe(
        switchMap(() => of(new ShowAlert(new InfoMessage('report.request.generate.note')))),
        catchError((error: Error) => of(new ExportPdfBulkFail(error)))
      )
    )
  ));

  constructor(private actions$: Actions,
    private gridService: GridService,
    private bulkExportDataService: BulkExportDataService) {
  }
}
